import { PREFERENCE_SHOW_OFF, PREFERENCE_SET_LOADING_STATUS, PREFERENCE_EDIT_MODE } from '../types'
import notify from '@/api/notification'
import { groupObjectByKey } from '../../utils/groupObjectByKey'
import { mergeTwoArraysOfObjects } from '../../utils/mergeTwoArraysOfObjects'
import { getCookie } from '../../utils/auth-utils'
import strings from '../../strings'
import preferences from '@/api/preferences'

const state = {
  preferenceShowOff: false,
  preferencesLoading: 'STATUS_INITIAL',
  profile: getCookie('profile') || null,
  preferencesWithOptions: [],
  userPreferences: getCookie('preferences') || null
}

const mutations = {
  [PREFERENCE_SHOW_OFF](state, value) {
    state.preferenceShowOff = value
  },
  [PREFERENCE_SET_LOADING_STATUS](state, value) {
    state.preferencesLoading = value
  },
  [PREFERENCE_EDIT_MODE](state, value) {
    state.preferencesWithOptions = value
  }
}

const getters = {
  isPreferenceVisible: state => {
    return state.preferenceShowOff
  },
  preferencesLoading: state => {
    return state.preferencesLoading
  },
  preference: state => {
    let preference = state.preferencesWithOptions ? state.preferencesWithOptions : strings.defaultPreferences
    preference = groupObjectByKey(preference, 'name')
    Object.keys(preference).map(function (key) {
      if (preference[key][0].value !== null) {
        preference[key] =
          typeof preference[key][0].value === 'object' ? preference[key][0].value.value : preference[key][0].value
        return preference[key]
      } else {
        preference[key] = null
        return preference[key]
      }
    })
    return preference
  },
  preferencesWithOptions: state => {
    return state.preferencesWithOptions
  }
}

const actions = {
  setPreferenceShowOff: function ({ commit }, value) {
    commit(PREFERENCE_SHOW_OFF, value)
  },
  saveUserPreferences: function ({ dispatch, commit }, newPreferences) {
    commit(PREFERENCE_SET_LOADING_STATUS, 'STATUS_LOADING')
    let preferencesFiltered
    preferencesFiltered = newPreferences.filter(function (item) {
      return item.userPreferenceValueId !== null
    })
    preferencesFiltered.map(item => {
      delete item.values
      delete item.description
      delete item.enabled
      delete item.name
    })
    preferences.saveUserPreferences(preferencesFiltered).then(() => {
      dispatch('getUserPreferences')
      notify({
        title: 'AVISO: ',
        message: 'Preferências gravadas com sucesso.'
      })
    })
  },
  editUserPreference: function ({ dispatch }, preferences) {
    if (state.profile === null) {
      dispatch('getUserProfile')
    }
    preferences.map(item => {
      if (item.values.length > 2) {
        if (item.enabled && item.value) {
          item.userPreferenceValueId = item.value.userPreferenceValueId
          item.value = item.value.value
        } else {
          let optionNull = item.values.filter(item => item.value === null)[0]
          item.value = optionNull.value
          item.userPreferenceValueId = optionNull.userPreferenceValueId
        }
      } else if (item.values.length <= 2) {
        var valueConverted = item.enabled ? 'S' : 'N'
        var selected = item.values.find(element => {
          if (element.value === valueConverted) {
            return element
          }
        })
        item.value = selected.value
        item.userPreferenceValueId = selected.userPreferenceValueId
      }
    })
    dispatch('saveUserPreferences', preferences)
  },
  getPreferencesOptions: function ({ commit }) {
    commit(PREFERENCE_SET_LOADING_STATUS, 'STATUS_LOADING')
    preferences.getPreferencesOptions().then(response => {
      let options
      let preferencesValues

      if (response.data.length > 1) {
        options = response.data
      } else {
        options = strings.defaultPreferences
      }

      if (getCookie('preferences')) {
        preferencesValues = getCookie('preferences')
      } else {
        preferencesValues = strings.defaultPreferences
      }

      let preferencesMergedWithOptions = mergeTwoArraysOfObjects(preferencesValues, options)

      preferencesMergedWithOptions.map(item => {
        if (item.values && item.values.length > 2) {
          let optionString = strings[item.name].filter(options => options.value === item.value)
          item.value = optionString.length > 0 ? optionString : { value: null }
          item.value[0].userPreferenceValueId = item.userPreferenceValueId
          item.value = item.value[0]
          item.enabled = item.value.value !== null
        } else {
          item.enabled = item.value === 'S'
        }
      })

      commit(PREFERENCE_EDIT_MODE, preferencesMergedWithOptions)
      commit(PREFERENCE_SET_LOADING_STATUS, 'STATUS_END')
    })
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
